import { TREE_COUNTER_URL } from "@/utils/constants";

const TREE_COUNT_KEY = "treeCount";
const TREE_COUNT_TIMESTAMP_KEY = "treeCountTimestamp";
const CACHE_DURATION = 1000 * 60 * 30; // 30 minutes cache
const FALLBACK_TREES_COUNT = "1,726,971";

const formatTreeCount = (count) =>
  new Intl.NumberFormat("en-US").format(
    Number(String(count).replace(/,/g, ""))
  );

const isTreesResponse = (response) => {
  return (
    typeof response === "object" &&
    response !== null &&
    "count" in response &&
    typeof response.count === "string"
  );
};

export async function getTreeCount() {
  try {
    const cachedTreeCount = localStorage.getItem(TREE_COUNT_KEY);
    const cachedTimestamp =
      Number(localStorage.getItem(TREE_COUNT_TIMESTAMP_KEY)) || 0;

    if (cachedTreeCount && Date.now() - cachedTimestamp <= CACHE_DURATION) {
      return formatTreeCount(cachedTreeCount);
    }

    const response = await fetch(TREE_COUNTER_URL);
    if (!response.ok) throw new Error(`API responded with ${response.status}`);

    const json = await response.json();
    if (!isTreesResponse(json)) throw new Error("Invalid API response");

    const apiTreeCount = json.count;

    // Update cache only if new data is valid
    localStorage.setItem(TREE_COUNT_KEY, apiTreeCount);
    localStorage.setItem(TREE_COUNT_TIMESTAMP_KEY, Date.now().toString());

    return formatTreeCount(apiTreeCount);
  } catch (error) {
    console.error("Failed to fetch tree count:", error);
    return formatTreeCount(
      localStorage.getItem(TREE_COUNT_KEY) || FALLBACK_TREES_COUNT
    );
  }
}
